import { ResourceLoader, Dimension, toSquareAngle, ResourceLoadState, ResourceState, ResourceType } from './imageviewer.model';
import { ImageCacheService } from './imagecache.service';
import { ImageViewerConfig } from './imageviewer.config';

declare var PDFJS;
export class PdfResourceLoader extends ResourceLoader {
private _pdf;
private _page;
private _pendingReload;
/**
 * @param {?} _imageCache
 */
constructor(private _imageCache: ImageCacheService) {
    super();
    if (!PDFJS.workerSrc) {
      PDFJS.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${(PDFJS as any).version}/pdf.worker.min.js`;
    }
    this.showItemsQuantity = true;
  }
/**
 * @return {?}
 */
setUp() {
    if (this.loadState === ResourceLoadState.Loading || !this.src) {
      return;
    }
    const /** @type {?} */ loadingTask: any = PDFJS.getDocument(this.src);
    const /** @type {?} */ vm = this;
    this.loadState = ResourceLoadState.Loading;
    this.currentItem = 1;
    loadingTask.promise.then((pdf) => {
      vm._pdf = pdf;
      vm.totalItem = pdf.numPages;
      vm.loadState = ResourceLoadState.Loaded;
      vm.loadResource();
    }, (reason) => {
      vm.loadState = ResourceLoadState.Failed;
      this.onLoadError.emit(reason);
      this.resourceChange.next();
    });
  }
/**
 * @return {?}
 */
loadResource() {
    if (this.loadState !== ResourceLoadState.Loaded) {
      this._pendingReload = true;
      return;
    }

    const /** @type {?} */ vm = this;
    const /** @type {?} */ url = this.src;
    const /** @type {?} */ page = this.currentItem;
    const /** @type {?} */ resourceState: ResourceState = {
      currentPage: page,
      numOfPages: this._pdf.numPages,
      type: ResourceType.PDF,
    };

    this.loadState = ResourceLoadState.Pristine;

    this._pdf.getPage(page).then((pdfPage) => {
      this.onResourceStateChange.emit(resourceState);
      vm._page = pdfPage;
      vm.loadImage(url, page, () => {
        vm.loadState = ResourceLoadState.Loaded;

        if (vm._pendingReload) {
          vm._pendingReload = false;
          vm.loadResource();
        } else {
          vm.resourceChange.next();
        }
      });
    });
  }
/**
 * @param {?} src
 * @param {?} page
 * @param {?} onFinish
 * @return {?}
 */
private loadImage(src: string, page: number, onFinish: () => void) {
    const /** @type {?} */ vm = this;
    const /** @type {?} */ cacheimg = this._imageCache.getImage(src, page);
    if (cacheimg) {
      vm._image = cacheimg;
      onFinish();
      return;
    }

    const /** @type {?} */ canvas: HTMLCanvasElement = document.createElement('canvas');
    const /** @type {?} */ context = canvas.getContext('2d');
    const /** @type {?} */ pageVp = this._page.getViewport(2);

    canvas.width = pageVp.width;
    canvas.height = pageVp.height;

    const /** @type {?} */ renderContext = {
      canvasContext: context,
      viewport: pageVp
    };
    const /** @type {?} */ renderTask = this._page.render(renderContext);
    renderTask.then(function () {
      canvas.toBlob(blob => {
        const /** @type {?} */ img = new Image();
        img.onload = onFinish;
        img.src = URL.createObjectURL(blob);
        vm._imageCache.saveImage(src, page, img);
        vm._image = img;
      });
    });
  }
}

function PdfResourceLoader_tsickle_Closure_declarations() {
/** @type {?} */
PdfResourceLoader.prototype._pdf;
/** @type {?} */
PdfResourceLoader.prototype._page;
/** @type {?} */
PdfResourceLoader.prototype._pendingReload;
/** @type {?} */
PdfResourceLoader.prototype._imageCache;
}

